$(document).scroll(function () {
  var y = $(this).scrollTop();
  if (y > 650) {
    $(".call-mob").addClass("show-btn");
  } else {
    $(".call-mob").removeClass("show-btn");
  }
});

$(".notification_img").hide();
$(".footer-close").hide();
$(document).ready(function () {
  let screenWidth = $(window).width();
  console.log(screenWidth);

  if (screenWidth > 768) {
    $(".enquiryBtn").click(function (e) {
      e.preventDefault();
      $(".overlay").addClass("modal-backdrop fade show");
      $(".footer-section").addClass("darkBlueBgColor");
      $(".footer-section").removeClass("bgBlueDark");
      $(".notification_img").show();
      $("#call-back-form").css({ padding: "20px" });
      $(".footer-section").animate({ height: 120 }, 200);
      $("#name").focus();
      $(".footer-close").show();
    });

    $(".footer-close").click(function (e) {
      e.preventDefault();
      $(".overlay").removeClass("modal-backdrop fade show");
      $(".footer-section").addClass("bgBlueDark");
      $(".notification_img").hide();
      $("#call-back-form").css({ padding: "0" });
      $(".footer-section").removeClass("darkBlueBgColor");
      $(".footer-section").animate({ height: 70 }, 200);
      $(".footer-close").hide();
    });
  } else {
    $(".enquiryBtn").click(function () {
      window.location.href = "#free-call";
    });
  }
});

/*
$(document).ready(function() {
  $('#call-back-form').submit(function(e) {
    e.preventDefault();
    let name = $('#name').val();
    let phone = $('#phone').val();
    let email = $('#email').val();

    AjaxSendForm(name, email, phone);
  
  });
});

function AjaxSendForm(name, email, phone) {
  $.ajax({
      type: 'POST',
      url: 'callBack.php',
      data: {name: name, email: email, phone: phone},
      beforeSend: function() {
          $('.call-btn').text('Submitting');
          $('.call-btn').attr('disabled', 'disabled');
          $(".name_err").text('');
          $(".phone_err").text('');
          $(".email_err").text('');
      },
      success: function(response) {
        if (!response.success) {
          if (response.errors.name) {
            $(".name_err").text(response.errors.name);
          }

          if (response.errors.phone) {
            $(".phone_err").text(response.errors.phone);
          }

          if (response.errors.email) {
            $(".email_err").text(response.errors.email); 
          }
          $('.call-btn').text('Get Free Call Now');
          $('.call-btn').removeAttr('disabled', 'disabled');
        } else {
          window.location.href = 'thank-you.html';
        }
      },
      error: function(xhr) {
        alert("Error occured.please try again");
        $('.call-btn').text('Get Free Call Now');
        $('.call-btn').removeAttr('disabled', 'disabled');
      },
      complete: function() {
        $('.response').removeClass('loading');
        $('.call-btn').text('Get Free Call Now');
        $('.call-btn').removeAttr('disabled', 'disabled');
      },
      dataType: 'json'
  });
}

*/

$(document).ready(function () {
  $(".keywords-sec").hide();
  $(".close-footer > span").click(function () {
    $(".keywords-sec").slideToggle();
    $(this).find("i").toggleClass("rotate-footer-close-arrow");
    // $(".close-footer").toggleClass("mb-5 mb-md-0");
    if ($(this).find("span").text() == "Close footer") {
      $(this).find("span").text("Open footer");
    } else {
      $(this).find("span").text("Close footer");
      $("html, body").animate({ scrollTop: $(document).height() }, 1000);
    }
  });
});

$(".collapser").click(function () {
  $(this).parent().next().collapse("toggle");
  $(this).toggleClass("package-details");
  $(".collapser").not(this).parent().next().collapse("hide");
  $(".collapser").not(this).removeClass("package-details");
});

$(document).ready(function () {
  $(".patients-slider").slick({
    arrows: false,
    dots: true,
    autoplay: false,
    autoplaySpeed: 1500,
    draggable: true,
    easing: true,
    swipe: true,
    useTransform: true,
    zIndex: 0,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,

          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.1,
          autoplay: false,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          autoplay: false,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".dr-slider").slick({
    arrows: false,
    dots: false,
    autoplay: false,
    autoplaySpeed: 1500,
    draggable: true,
    easing: true,
    swipe: true,
    useTransform: true,
    zIndex: 0,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,

          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.3,
          autoplay: false,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          autoplay: false,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".appointment-btn").click(function () {
    $(".overlay").addClass("modal-backdrop fade show");
    $("body").addClass("no-overflow");

    $(".form-cov").addClass("form-high");
    setTimeout(function () {
      $(".form-close").show();
    }, 500);
    if ($(window).width() >= 768) {
      window.location.href = "#form-d";
      $(".name-f").focus();
    } else {
      window.location.href = "#";
    }
  });

  $(".form-close").click(function () {
    $(".overlay").removeClass("modal-backdrop fade show");
    $(".form-cov").removeClass("form-high");
    $("body").removeClass("no-overflow");
    $(this).hide();
  });
});

function onlyNumberKey(evt) {
  // Only ASCII character in that range allowed
  var ASCIICode = evt.which ? evt.which : evt.keyCode;
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
  return true;
}

// Start OTP functionality

// OTP functionality
let otpSent = false;
let otpVerified = false; // Track if OTP is currently verified
let otpTimer = null;
let timeLeft = 0;

function sendOTP() {
  const phoneInput = document.getElementById('phone');
  const otpBtn = document.getElementById('sendOtpBtn');
  const phoneNumber = phoneInput.value.trim();
  
  // Reset verification status when sending new OTP
  otpVerified = false;
  
  // Validate phone number first
  if (!phoneNumber || phoneNumber.length !== 10) {
    // alert('Please enter a valid 10-digit mobile number first');
    phoneInput.focus();
    return;
  }
  
  // Disable button and show loading state
  otpBtn.disabled = true;
  otpBtn.innerHTML = 'Sending...';
  
  // Make AJAX call to send OTP
  fetch('send_otp.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone: phoneNumber
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // alert(data.message);
      otpSent = true;
      
      // Start countdown timer (30 seconds)
      timeLeft = 30;
      updateOtpButton();
      startOtpTimer();
      
      // Focus on OTP input
      document.getElementById('otp').focus();
    } else {
      // alert('Error: ' + data.message);
      otpBtn.disabled = false;
      otpBtn.innerHTML = 'Send OTP';
    }
  })
  .catch(error => {
    console.error('Error:', error);
    // alert('Failed to send OTP. Please try again.');
    otpBtn.disabled = false;
    otpBtn.innerHTML = 'Send OTP';
  });
}


function updateOtpButton() {
  const otpBtn = document.getElementById('sendOtpBtn');
  
  if (timeLeft > 0) {
    otpBtn.disabled = true;
    otpBtn.innerHTML = `Resend OTP (${timeLeft}s)`;
  } else {
    otpBtn.disabled = false;
    otpBtn.innerHTML = 'Resend OTP';
  }
}

function startOtpTimer() {
  otpTimer = setInterval(() => {
    timeLeft--;
    updateOtpButton();
    
    if (timeLeft <= 0) {
      clearInterval(otpTimer);
    }
  }, 1000);
}

// Verify OTP function (for real-time validation)
function verifyOTP(phone, otp) {
  return fetch('verify_otp.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone: phone,
      otp: otp
    })
  })
  .then(response => response.json());
}

// Final verify OTP function (for form submission)
function finalVerifyOTP(phone, otp) {
  return fetch('final_verify_otp.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone: phone,
      otp: otp
    })
  })
  .then(response => response.json());
}

// Validate OTP on input and form submission
document.addEventListener('DOMContentLoaded', function() {
  const otpInput = document.getElementById('otp');
  const phoneInput = document.getElementById('phone');
  const form = document.querySelector('form');
  
  // Initially disable the OTP input field
  if (otpInput) {
    otpInput.disabled = true;
    otpInput.style.backgroundColor = '#f5f5f5';
    otpInput.placeholder = 'Enter OTP';
  }
  
  // Monitor phone input changes to enable/disable OTP field
  if (phoneInput) {
    phoneInput.addEventListener('input', function() {
      const phoneNumber = this.value.trim();
      const phoneError = document.querySelector('.phone_err');
      
      if (phoneNumber.length === 10 && /^\d{10}$/.test(phoneNumber)) {
        // Valid 10-digit mobile number entered - enable OTP field and show checkmark in input
        if (otpInput) {
          otpInput.disabled = false;
          otpInput.style.backgroundColor = '';
          otpInput.placeholder = 'Enter OTP*';
        }
        
        // Add checkmark inside the input box
        phoneInput.style.backgroundImage = "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"%23198754\" viewBox=\"0 0 16 16\"><path d=\"M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z\"/></svg>')";
        phoneInput.style.backgroundRepeat = 'no-repeat';
        phoneInput.style.backgroundPosition = 'right 12px center';
        phoneInput.style.backgroundSize = '24px 24px';
        phoneInput.style.paddingRight = '45px';
        
        // Clear any error messages
        if (phoneError) {
          phoneError.textContent = '';
        }
      } else {
        // Invalid or incomplete mobile number - disable OTP field and remove checkmark
        if (otpInput) {
          otpInput.disabled = true;
          otpInput.style.backgroundColor = '#f5f5f5';
          otpInput.placeholder = 'Enter mobile number first';
          otpInput.value = ''; // Clear OTP field
          otpVerified = false; // Reset verification status
          
          // Clear any OTP error messages
          const otpError = document.querySelector('.otp_err');
          if (otpError) {
            otpError.textContent = '';
          }
        }
        
        // Remove checkmark from input box
        phoneInput.style.backgroundImage = 'none';
        phoneInput.style.paddingRight = '';
        
        // Clear mobile number error messages
        if (phoneError) {
          phoneError.textContent = '';
        }
      }
    });
  }
  
  if (otpInput) {
    otpInput.addEventListener('input', function() {
      const otpValue = this.value;
      const otpError = document.querySelector('.otp_err');
      const otpBtn = document.getElementById('sendOtpBtn');
      
      // Reset verification status when OTP is modified
      otpVerified = false;
      
      if (otpValue.length === 6) {
        const phoneNumber = document.getElementById('phone').value.trim();
        
        if (phoneNumber) {
          // Verify OTP when 6 digits are entered
          verifyOTP(phoneNumber, otpValue)
            .then(data => {
              if (otpError) {
                if (data.success) {
                  otpVerified = true; // Set verification status to true
                  otpError.textContent = '';
                  otpError.style.color = 'green';
                  otpError.textContent = '✓ OTP verified successfully';
                  
                  // Disable the Resend OTP button when OTP is verified
                  if (otpBtn) {
                    otpBtn.disabled = true;
                    otpBtn.innerHTML = '✓ Verified';
                    otpBtn.style.backgroundColor = '#d4edda';
                    otpBtn.style.borderColor = '#c3e6cb';
                    otpBtn.style.color = '#155724';
                    
                    // Clear any existing timer
                    if (otpTimer) {
                      clearInterval(otpTimer);
                      otpTimer = null;
                      timeLeft = 0;
                    }
                  }
                } else {
                  otpVerified = false; // Set verification status to false
                  otpError.style.color = 'red';
                  otpError.textContent = data.message;
                }
              }
            })
            .catch(error => {
              console.error('Error:', error);
              otpVerified = false; // Set verification status to false on error
              if (otpError) {
                otpError.style.color = 'red';
                otpError.textContent = 'Error verifying OTP';
              }
            });
        }
      } else {
        // Clear error message and reset verification status for incomplete OTP
        if (otpError) {
          otpError.textContent = '';
        }
        otpVerified = false;
        
        // Re-enable Resend OTP button if OTP is incomplete and was previously verified
        const otpBtn = document.getElementById('sendOtpBtn');
        if (otpBtn && (otpBtn.innerHTML === '✓ OTP Verified' || otpBtn.innerHTML === 'OTP Verified')) {
          // Restore the button to its previous state (either with timer or ready to resend)
          if (otpSent) {
            if (timeLeft > 0) {
              otpBtn.innerHTML = `Resend OTP (${timeLeft}s)`;
              otpBtn.disabled = true;
            } else {
              otpBtn.innerHTML = 'Resend OTP';
              otpBtn.disabled = false;
            }
            // Reset button styling
            otpBtn.style.backgroundColor = '';
            otpBtn.style.borderColor = '';
            otpBtn.style.color = '';
          }
        }
      }
    });
  }
  
  // Add form submission validation
  if (form) {
    form.addEventListener('submit', function(e) {
      const phoneNumber = document.getElementById('phone').value.trim();
      const otpValue = document.getElementById('otp').value.trim();
      
      if (!otpSent) {
        e.preventDefault();
        // alert('Please send OTP first');
        return false;
      }
      
      if (otpValue.length !== 6) {
        e.preventDefault();
        // alert('Please enter a valid 6-digit OTP');
        document.getElementById('otp').focus();
        return false;
      }
      
      if (!otpVerified) {
        e.preventDefault();
        // alert('Please verify your OTP before submitting the form');
        document.getElementById('otp').focus();
        return false;
      }
      
      // Prevent form submission and do final verification
      e.preventDefault();
      
      // Show loading state
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Verifying...';
      
      // Do final OTP verification
      finalVerifyOTP(phoneNumber, otpValue)
        .then(data => {
          if (data.success) {
            // OTP verified successfully, submit the form
            submitBtn.innerHTML = 'Submitting...';
            form.submit();
          } else {
            // Final verification failed
            // alert('Error: ' + data.message);
            otpVerified = false; // Reset verification status
            const otpError = document.querySelector('.otp_err');
            if (otpError) {
              otpError.style.color = 'red';
              otpError.textContent = data.message;
            }
            
            // Restore button
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
        })
        .catch(error => {
          console.error('Error:', error);
          // alert('Failed to verify OTP. Please try again.');
          
          // Restore button
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        });
      
      return false; // Always prevent default submission
    });
  }
});

// end OTP functionality
